import { Chart } from "@appretio/ui-kit";
import { PriceDilutionApiRow } from "../../../pages/inSeasonReviewPage/hooks/useFetchPriceDilution";
import { chartWrapper } from "../Chart.css";
import { usePriceDilutionOptions } from "./hooks/usePriceDilutionOptions";

interface PriceDilutionChartProps {
  /**
   * Full dataset
   */
  priceDilutionData: PriceDilutionApiRow[] | undefined;

  /**
   * Loading state
   */
  isLoading: boolean;
}

const CHART_TITLE = "Price Dilution";
const CHART_SUBTITLE = "Retail = [total value sold]/[total units sold]";
const SUBTITLE_FONT_SIZE = 12;

export function PriceDilutionChart({
  priceDilutionData,
  isLoading
}: PriceDilutionChartProps) {
  const { series, axes } = usePriceDilutionOptions(priceDilutionData);

  return (
    <div className={chartWrapper}>
      <Chart
        isLoading={isLoading}
        options={{
          title: { text: CHART_TITLE },
          subtitle: {
            text: CHART_SUBTITLE,
            fontSize: SUBTITLE_FONT_SIZE,
            textAlign: "right"
          },
          legend: { enabled: false },
          tooltip: { mode: "shared" },
          series: series,
          axes: axes,
          zoom: {
            enabled: priceDilutionData && priceDilutionData.length > 0,
            enableAxisDragging: false,
            autoScaling: {
              enabled: true
            }
          }
        }}
      />
    </div>
  );
}
